var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SimpleLimitsService } from './../../api/simple-limits.service';
import { PropertyService } from './../../api/property.service';
import { OnInit, Injector } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AbstractPropertiesSearch } from './index';
var AdvancedSearchBaseComponent = /** @class */ (function (_super) {
    __extends(AdvancedSearchBaseComponent, _super);
    function AdvancedSearchBaseComponent(router, route, propertyService, simpleLimitsService, injector, window) {
        var _this = _super.call(this, injector, window) || this;
        _this.route = route;
        _this.propertyService = propertyService;
        _this.simpleLimitsService = simpleLimitsService;
        _this.window = window;
        _this.isOpen = false;
        _this.years_built = ['built_new', 'built_2000', 'built_1990', 'built_1977', 'built_under_construction', 'built_project'];
        _this.home_types = ['apartment', 'studio', '1bedroom', 'penthouse'];
        return _this;
    }
    AdvancedSearchBaseComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.data.forEach(function (data) {
            _this.validateRouteDataParams(data, ['property_type', 'advanced_limits', 'simple_limits']);
            _this.currentPropertyType = data.property_type;
            _this.advancedLimits = data.advanced_limits;
            _this.simpleLimits = data.simple_limits;
        });
        this.route.queryParams
            .subscribe(function (params) {
            _this.validateRouteQueryParams(params);
            AbstractPropertiesSearch.propertySearch = _this.propertyService.decodeUrlParams(params, _this.advancedLimits);
            AbstractPropertiesSearch.propertySearch.property_type = _this.currentPropertyType;
            _this.addSearchDefaults();
        });
        this.addSearchDefaults();
        this.resetSlidersSearch();
    };
    AdvancedSearchBaseComponent.prototype.propertyTypeChange = function () {
        this.router.navigate([AbstractPropertiesSearch.propertySearch.property_type]);
    };
    AdvancedSearchBaseComponent.prototype.addSearchDefaults = function () {
        if (!AbstractPropertiesSearch.propertySearch.for_sale && !AbstractPropertiesSearch.propertySearch.to_let) {
            AbstractPropertiesSearch.propertySearch.for_sale = true;
            AbstractPropertiesSearch.propertySearch.listing = 'for_sale';
        }
    };
    AdvancedSearchBaseComponent.prototype.resetSlidersSearch = function () {
        AbstractPropertiesSearch.propertySearch.min_size_sqm = this.advancedLimits.min_size_sqm;
        AbstractPropertiesSearch.propertySearch.max_size_sqm = this.advancedLimits.max_size_sqm;
        AbstractPropertiesSearch.propertySearch.min_buy_price_eur = this.advancedLimits.min_buy_price_eur;
        AbstractPropertiesSearch.propertySearch.max_buy_price_eur = this.advancedLimits.max_buy_price_eur;
        AbstractPropertiesSearch.propertySearch.min_let_price_eur = this.advancedLimits.min_let_price_eur;
        AbstractPropertiesSearch.propertySearch.max_let_price_eur = this.advancedLimits.max_let_price_eur;
        AbstractPropertiesSearch.propertySearch.min_front_length_m = this.advancedLimits.min_front_length_m;
        AbstractPropertiesSearch.propertySearch.max_front_length_m = this.advancedLimits.max_front_length_m;
        AbstractPropertiesSearch.propertySearch.min_land_size_sqm = this.advancedLimits.min_land_size_sqm;
        AbstractPropertiesSearch.propertySearch.max_land_size_sqm = this.advancedLimits.max_land_size_sqm;
    };
    AdvancedSearchBaseComponent.prototype.createRoomCounts = function (minRoomCount, maxRoomCount) {
        var roomCounts = new Array();
        for (var i = minRoomCount; i <= maxRoomCount; i++) {
            roomCounts.push(i);
        }
        return roomCounts;
    };
    AdvancedSearchBaseComponent.prototype.createRoomCountLabel = function (roomCount) {
        if (roomCount === 1) {
            return 'garsonieră';
        }
        else {
            return roomCount + " camere";
        }
    };
    AdvancedSearchBaseComponent.prototype.resetFiltersRoute = function () {
        this.router.navigate(['.'], { relativeTo: this.route, queryParams: {} });
    };
    AdvancedSearchBaseComponent.prototype.onSubmit = function () {
        if (AbstractPropertiesSearch.propertySearch.listing === 'for_sale') {
            AbstractPropertiesSearch.propertySearch.for_sale = true;
            AbstractPropertiesSearch.propertySearch.to_let = false;
        }
        else if (AbstractPropertiesSearch.propertySearch.listing === 'to_let') {
            AbstractPropertiesSearch.propertySearch.for_sale = false;
            AbstractPropertiesSearch.propertySearch.to_let = true;
        }
        for (var field in AbstractPropertiesSearch.propertySearch) {
            if (AbstractPropertiesSearch.propertySearch.hasOwnProperty(field) && !AbstractPropertiesSearch.propertySearch[field]) {
                delete AbstractPropertiesSearch.propertySearch[field];
            }
        }
        this.router.navigate([AbstractPropertiesSearch.propertySearch.property_type], { queryParams: AbstractPropertiesSearch.propertySearch, fragment: 'list' });
    };
    return AdvancedSearchBaseComponent;
}(AbstractPropertiesSearch));
export { AdvancedSearchBaseComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/advanced-search-base.component.ts.pre-build-optimizer.js